<div class="rental-report" *ngIf="!loading(); else spinner">
  <div class="page-header">
    <button mat-icon-button [routerLink]="['/rentals', rentalId()]" aria-label="Назад к прокату">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <h1 class="page-title">Отчёт по прокату</h1>
  </div>

  <p class="hint">На iPhone/в Telegram используйте «Поделиться», чтобы сохранить переносы строк.</p>

  <pre class="report-text" [class.is-loading]="paymentsLoading()">{{ reportText() }}</pre>

  <div class="loading-inline" *ngIf="paymentsLoading()">
    <mat-spinner diameter="20"></mat-spinner>
    <span>Подгружаем платежи…</span>
  </div>

  <div class="actions">
    <button mat-raised-button color="primary" type="button" (click)="share()"
            [disabled]="!reportText()" class="full-width-btn">
      <mat-icon>share</mat-icon> Поделиться
    </button>
    <button mat-stroked-button type="button" (click)="copy()"
            [disabled]="!reportText()" class="full-width-btn">
      <mat-icon>content_copy</mat-icon> Скопировать
    </button>
    <button mat-stroked-button type="button" [routerLink]="['/rentals', rentalId()]" class="full-width-btn">
      <mat-icon>arrow_back</mat-icon> Назад к прокату
    </button>
  </div>
</div>

<ng-template #spinner>
  <div class="loading-container"><mat-spinner diameter="40"></mat-spinner></div>
</ng-template>
